import gql from "graphql-tag";

export default gql`
  mutation JoinWaitlistViaSystemeTag(
    $email: EmailAddress!
    $tag: String!
    $turnstileToken: String
    $turnstileIdempotencyKey: String
  ) {
    joinWaitlistViaSystemeTag(
      email: $email
      tag: $tag
      turnstileToken: $turnstileToken
      turnstileIdempotencyKey: $turnstileIdempotencyKey
    )
  }
`;
